import React from "react";

const VectorStarfish = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Rounded Star Shape - More "Cute" */}
            <path
                d="M20 2 C21 2 23 12 25 14 C27 16 38 15 38 17 C38 19 28 22 27 25 C26 28 32 37 30 38 C28 39 23 30 20 30 C17 30 12 39 10 38 C8 37 14 28 13 25 C12 22 2 19 2 17 C2 15 13 16 15 14 C17 12 19 2 20 2 Z"
                fill="#FF7043"
                stroke="#E64A19"
                strokeWidth="1"
                strokeLinejoin="round"
            />
             {/* Dots */}
            <circle cx="20" cy="20" r="2" fill="#FFE0B2" />
            <circle cx="20" cy="10" r="1.5" fill="#FFE0B2" />
            <circle cx="28" cy="18" r="1.5" fill="#FFE0B2" />
            <circle cx="25" cy="28" r="1.5" fill="#FFE0B2" />
            <circle cx="15" cy="28" r="1.5" fill="#FFE0B2" />
            <circle cx="12" cy="18" r="1.5" fill="#FFE0B2" />
        </svg>
    );
};

export default VectorStarfish;
